import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ButtonBase } from '../../../../shared/Button';
import Text from '../../../../shared/Text';

export const SkippedState = ({ resetState }) => {
  const { t } = useTranslation('campaigns');

  const [isHovering, setIsHovering] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering ? (
        <ResetSkip onClick={resetState} mode="text" variant="black">
          <i className="fa-regular fa-rotate-left"></i>
          {t('upload.skippedState.resetState')}
        </ResetSkip>
      ) : (
        <StepSkipped as="div" variant="subtitle2">
          <i className="fa-regular fa-xmark"></i>
          {t('upload.skippedState.stepSkipped')}
        </StepSkipped>
      )}
    </div>
  );
};

const StepSkipped = styled(Text)`
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.7;
  padding: 8px 12px;
`;

const ResetSkip = styled(ButtonBase)`
  height: auto;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.7;
  display: flex;
  align-items: center;
  gap: 4px;
`;
